export const throttle = (fn, interval) => {
  let enterTime = 0;// 触发的时间
  const gapTime = interval || 300;// 间隔时间，如果interval不传，则默认300ms

  return function(...args: any[]) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this;
    const backTime: number = new Date().getTime();// 第一次函数return即触发的时间
    if (backTime - enterTime > gapTime) {
      // eslint-disable-next-line prefer-rest-params
      fn.call(context, { ...arguments[0] });
      enterTime = backTime;// 赋值给第一次触发的时间，这样就保存了第二次触发的时间
    }
  };
};

export const debounce = (fn, interval) => {
  let timer: any = null;
  const gapTime = interval || 300;// 间隔时间，如果interval不传，则默认300ms

  return function(...args: any[]) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this;
    clearTimeout(timer);
    timer = setTimeout(() => {
      // eslint-disable-next-line prefer-rest-params
      fn.call(context, { ...arguments[0] });
    }, gapTime);
  };
};


export function throttleArgs<T extends(...args: any[]) => any>(fn: T, interval: number): T {
  let shouldThrottle = false;
  let timeout: NodeJS.Timeout | null = null;

  const throttledFunction = (...args: Parameters<T>): void => {
    if (shouldThrottle) {
      return;
    }

    fn(...args);

    shouldThrottle = true;
    if (timeout !== null) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      shouldThrottle = false;
    }, interval);
  };

  // 返回原始函数类型
  return throttledFunction as T;
}


export default throttle;
